import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  allowRefundsTitle: {
    id: 'oyOE3w',
    defaultMessage: 'Allow refunds, exchanges, and store credit',
    description: 'Title for the enhanced mode toggle that allows customers to choose how to resolve a return',
  },
  allowRefundsDescription: {
    id: '29yE6X',
    defaultMessage:
      'Your customers can choose how they want to resolve a return. They can get their money back, exchange for a different product, or take store credit. ShipStation updates Shopify with refund and inventory updates automatically.',
    description: 'Description for the enhanced mode toggle explaining refund, exchange, and store credit options',
  },
});
